

/**
 * API Request handler
 * @param url - api endpoint
 * @param method - http method
 * @param bodyParams - body parameters of request
 */
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc)

const showDate = (date) => {
    const mdate = dayjs(date);
    return mdate.format('DD-MMM-YYYY');

}

const showTime = (date) => {
    const mdate = dayjs(date);
    return mdate.format("HH:mm");

}

const showDateTime = (date) => {
    const mdate = dayjs(date);
    return mdate.format('DD-MMM-YYYY') + ' ' + mdate.format("HH:mm");

}

const showDateUTC = (date) => {
    const mdate = dayjs.utc(date);
    return mdate.local().format('DD-MMM-YYYY');

}

const showTimeUTC = (date) => {
    const mdate = dayjs.utc(date);
    return mdate.local().format("HH:mm");

}

const showDateTimeUTC = (date) => {
    const mdate = dayjs.utc(date);
    return mdate.local().format('DD-MMM-YYYY') + ' ' + mdate.local().format("HH:mm");

}

export { showDate, showTime, showDateTime, showDateUTC, showTimeUTC, showDateTimeUTC}; 